module.exports = __webpack_public_path__ + "static/media/ABL_Aviation_logo.41733f25.svg";